module.exports = __webpack_public_path__ + "static/death-in-the-ladies-goddess-club-a16376988b8d95bf50e5ef0ca52736b0.jpg";